export default __webpack_public_path__ + "static/media/2.df897aa2.webp";